// src/components/Sidebar.jsx

import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Sidebar.css";

const Sidebar = ({ collapsed }) => {

  const [user] = useState({
    name: "Admin User",
    role: "Administrator"
  });

  const sliderbarcloser = () => {

    document.querySelector(".main-content")?.classList.add("collapsed");
    document.querySelector(".sidebar")?.classList.add("collapsed");

  };

  const getInitials = (name) => {

    if (!name) return "";

    const parts = name.trim().split(" ");

    return parts.length > 1
      ? (parts[0][0] + parts[1][0]).toUpperCase()
      : parts[0][0].toUpperCase();

  };

  const initials = getInitials(user?.name);

  return (

    <aside className={`sidebar${collapsed ? " collapsed" : ""}`}>

      {/* Header */}

      <div className="slidebar-header">

        <section>

          <img src="https://rbhardwaj.com/Homeimages/tick-icon.png" alt="" />

          <h2 className="sidebar-nav__title">
            Admin 
          </h2>

        </section>

        <span
          style={{
            cursor: "pointer",
            fontSize: "25px",
            transform: "rotate(-90deg)",
            color: "#2e2e2e"
          }}
          onClick={sliderbarcloser}
        >
          ❮
        </span>

      </div>

      {/* Profile */}

      <div className="slidebar-profile">

        <section>

          <div className="header__avatar-initials profile-img">
            {initials}
          </div>

          <div style={{ fontSize: "13px" }}>
            <h4>{user?.name}</h4>
            <small>{user?.role}</small>
          </div>

          <span>›</span>

        </section>

      </div>

      {/* Navigation */}

      <nav className="sidebar__nav">

        <NavLink
          to=""
          end
          className={({ isActive }) =>
            `sidebar__link${isActive ? " active" : ""}`
          }
        >
          <span className="sidebar__icon">🏠</span>
          <span>Dashboard</span>
        </NavLink>

        <NavLink
          to="employee"
          className={({ isActive }) =>
            `sidebar__link${isActive ? " active" : ""}`
          }
        >
          <span className="sidebar__icon">👥</span>
          <span>Employee</span>
        </NavLink>

        <NavLink
          to="attendance"
          className={({ isActive }) =>
            `sidebar__link${isActive ? " active" : ""}`
          }
        >
          <span className="sidebar__icon">📅</span>
          <span>Attendance</span>
        </NavLink>

       

        <NavLink
          to="holiday"
          className={({ isActive }) =>
            `sidebar__link${isActive ? " active" : ""}`
          }
        >
          <span className="sidebar__icon">🎉</span>
          <span>Holiday</span>
        </NavLink>

        <NavLink
          to="expenses"
          className={({ isActive }) =>
            `sidebar__link${isActive ? " active" : ""}`
          }
        >
          <span className="sidebar__icon">📊</span>
          <span>Expenses</span>
        </NavLink>

        <NavLink
          to="leave-applications"
          className={({ isActive }) =>
            `sidebar__link${isActive ? " active" : ""}`
          }
        >
          <span className="sidebar__icon">📝</span>
          <span>Leave</span>
        </NavLink>

        <NavLink
          to="tasks"
          className={({ isActive }) =>
            `sidebar__link${isActive ? " active" : ""}`
          }
        >
          <span className="sidebar__icon">✅</span>
          <span>Tasks Assign</span>
        </NavLink>

 <NavLink
          to="salary"
          className={({ isActive }) =>
            `sidebar__link${isActive ? " active" : ""}`
          }
        >
          <span className="sidebar__icon">💰</span>
          <span>Salary</span>
        </NavLink>
        
        <NavLink
          to="reports"
          className={({ isActive }) =>
            `sidebar__link${isActive ? " active" : ""}`
          }
        >
          <span className="sidebar__icon">📈</span>
          <span>Report Viewer</span>
        </NavLink>

      </nav>

    </aside>

  );

};

export default Sidebar;